import { AbstractControl, FormControl } from '@angular/forms';
import { CreditCardProcessor, CREDIT_CARD_PROCESSORS } from '../constants';
import { trimEnd } from 'lodash-es';

export const join = (
  arr: Array<string | null>,
  separator: string = '.',
  emptyArrayString: string = '',
  removeLastSeparator: boolean = false
): string => {
  const filteredArray = arr.filter((s) => !!s).map((s) => (typeof s === 'string' ? trimEnd(s, separator) : s));
  const untrimmedString = filteredArray.length > 0 ? filteredArray.join(separator + ' ') + separator : emptyArrayString;
  return removeLastSeparator ? trimEnd(untrimmedString, separator) : untrimmedString;
};

export const getCreditCardProcessor = (creditCardNumber?: string | null): CreditCardProcessor | null => {
  if (!creditCardNumber) return null;

  const number = creditCardNumber.replace(/\D/g, '');
  let foundProcessor = null;

  CREDIT_CARD_PROCESSORS.forEach((processor) => {
    processor.regexStrings.forEach((regexString) => {
      const regex = new RegExp(regexString);
      if (regex.test(number)) {
        foundProcessor = processor;
      }
    });
  });

  return foundProcessor;
};

export const asFormControl = (a: AbstractControl | null | undefined) => {
  return a ? (a as FormControl) : new FormControl(null);
};
